import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import MainTitle from '../../components/MainTitle'
import { Navigate, useParams } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { PhoneNumberUtil } from 'google-libphonenumber'
import AutoComplete from 'react-google-autocomplete'
import { useNavigate } from 'react-router-dom'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'

const GOOGLE_API_KEY = 'AIzaSyDcTd3xEx_Y4ZlRo-7eeoSWzLUnWO67LFU'

function CreateSchoolClient() {
  
  const { id } = useParams()
  const { setShowLoader, createInfo } = useAuth()
  const axios = useAxiosPrivate()
  const navigate = useNavigate()
  const [schoolFound, setSchoolFound] = useState(true)
  const [schoolData, setSchoolData] = useState({
    name: '',
    reference: 'WBA-1000',
  })
  const [submitting, setSubmitting] = useState(false)
  const [contactMethods, setContactMethods] = useState([])
  const [clientData, setClientData] = useState({})
  const [loading, setLoading] = useState(false)
  const [emergencyContact, setEmergencyContact] = useState({})
  const [isValid, setIsValid] = useState(false)
  const [validPhoneNumber, setValidPhoneNumber] = useState(true)
  const [emergencyContactAddress, setEmergencyContactAddress] = useState({})
  const [emergencyPhoneNumber, setEmergencyPhoneNumber] = useState('')
  const [safeguardDetails, setSafeguardDetails] = useState({})
  const [safeguardNumber, setSafeguardNumber] = useState('')
  const [validEmail, setValidEmail] = useState(true)
  const [validSafeGuardNumber, setValidSafeGuardNumber] = useState(true)
  const [allowedContactTypes] = useState([])

  useEffect(() => {
    getSchoolById()
    setEmergencyPhoneNumber('+44')
    if (!safeguardNumber) {
      setSafeguardNumber('+44')
    }
    getContactMethods()
  }, [id])

  const getContactMethods = async () => {
    try {
      const response = await axios.get(`/contact-methods/all`)
      setContactMethods(response.data.result)
    } catch (error) {}
  }


  const createClient = async (e) => {
    e.preventDefault()

    setSubmitting(true)

    //validate inputs
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,}$/
    const emailValid = emailRegex.test(safeguardDetails.email)
    if (!emailValid) {
      createInfo('error', `Please enter a valid email address`)
      setSubmitting(false)
      return
    }

    const data = {
      client: {
        name: clientData.name,
        email: schoolData.email,
        child: 1,
        status_id: 1,
        parent_id: schoolData.id,
        school: 0,
      },
      client_details: {
        date_of_birth: clientData.date_of_birth,
        region_id: schoolData.client_details.region_id,
        phone_number: schoolData.client_details.phone_number,
        emergency_contact: JSON.stringify({
          name: emergencyContact.name,
          contact_number: emergencyContact.contact_number,
          address: emergencyContact.address,
          relationship: emergencyContact.relationship,
        }),
        child_details: JSON.stringify({
          name: safeguardDetails.name,
          email: safeguardDetails.email,
          contact_number: safeguardDetails.contact_number,
        }),
        school_contact_name: schoolData.client_details.school_contact_name,
        school_address: schoolData.client_details.school_address,
        send_notifications: schoolData.client_details.send_notifications,
        contact_time: schoolData.client_details.contact_time
      },
    }

    try {
      const response = await axios.post(`/schools/${id}/create-client`, data)
      setShowLoader(false)
      if (response.data.error === false) {
        createInfo('success', `Created Client: ${clientData.name}`)
        navigate(`/schools/${id}/clients`)
        setSubmitting(false)
      }
    } catch (error) {
      console.log(error)
      setShowLoader(false)
    }
  }

  const handleSafeguardPhoneNumberChange = (event) => {
    const { value } = event.target
    setSafeguardNumber(value)
    const isValidNumber = validatePhoneNumber(value)
    setValidSafeGuardNumber(isValidNumber)
  }


  const updateEmergencyContactAddress = (address) => {
    let addressString = ''

    Object.keys(address).forEach((key, index) => {
      if (key === 'value') {
        return
      }

      if (!address[key] || address[key].trim() === '') {
        return
      }

      addressString += address[key]

      if (index !== Object.keys(address).length - 1) {
        addressString += ', '
      }
    })

    emergencyContact.address = addressString
  }

  const updateContactMethod = (method) => {
    let index = allowedContactTypes.indexOf(method.id)
    if (index === -1) {
      allowedContactTypes.push(method.id)
    } else {
      allowedContactTypes.splice(index, 1)
    }
  }

  const getSchoolById = async () => {
    try {
      setShowLoader(true)
      setLoading(true)

      const response = await axios.get(`/schools/${id}`)

      if (!response.data.error) {
        await setSchoolData(response.data.result)

        // setEnabled(response.data.result.client_details.send_notifications)
        // setEditSchoolContactName(response.data.result.client_details.school_contact_name)

        const contactMethodsArray = Object.values(
          response.data.result.contact_methods
        )

        // setEditContactMethod(contactMethodsArray)
        setSchoolFound(true)
      } else {
        setSchoolFound(false)
      }
      setLoading(false)
      setShowLoader(false)
    } catch (error) {
      setSchoolFound(false)
    } finally {
      setShowLoader(false)
    }
  }

  if (!schoolFound) {
    return <Navigate to="/404" replace />
  }

  const handleEmergencyPhoneNumberChange = (event) => {
    const { value } = event.target
    setEmergencyPhoneNumber(value)
    const isValidNumber = validatePhoneNumber(value)
    setIsValid(isValidNumber)
  }

  const validatePhoneNumber = (phoneNumber) => {
    const phoneNumberUtil = PhoneNumberUtil.getInstance()

    try {
      const parsedNumber = phoneNumberUtil.parse(phoneNumber, '+44')
      const isValidNumber = phoneNumberUtil.isValidNumber(parsedNumber)
      return isValidNumber
    } catch (e) {
      console.error('Error parsing phone number:', e)
      return false
    }
  }

  return (
    <section>
      <MainTitle title={`Create Child Client: ${schoolData.name}`} backButton />
        <form className="w-full relative" onSubmit={createClient}>
          <div className="mt-6">
            <div>
              <h3 className="text-md font-bold mb-2">School Info</h3>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="School_name"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School Name
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.name}
                      type="text"
                      name="School_name"
                      required
                      disabled
                      id="School_name"
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
                <div className="mb-3 w-1/2 ml-2">
                  <label
                    htmlFor="School_email"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School Email
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.email}
                      type="School_email"
                      required
                      name="email"
                      id="School_email"
                      disabled
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
              </div> 
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="school_address"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School Address
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.client_details?.school_address}
                      type="text"
                      name="School_address"
                      required
                      disabled
                      id="School_address"
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
              </div> 
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="school_region"
                    className="block text-xs font-medium text-gray-700"
                  >
                    School Region
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      value={schoolData.client_details?.region}
                      type="text"
                      name="school_region"
                      disabled
                      id="school_region"
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
              </div>       
            </div>
          </div>
          <hr className="bg-gray-300 w-full my-4" />
          <div className="mt-6">
            <h3 className="text-md font-bold mb-2">Client Details</h3>
            <div className="flex">
              <div className="mb-3 w-1/2 mr-2">
                <label
                  htmlFor="Client_name"
                  className="block text-xs font-medium text-gray-700"
                >
                  Client Name
                </label>
                <div className="mt-1 relative rounded-md">
                  <input
                    defaultValue={clientData.name}
                    type="text"
                    name="Client_name"
                    required
                    id="Client_name"
                    onChange={(e) => {
                      clientData.name = e.target.value
                    }}
                    className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                  />
                </div>
              </div>
              <div className="mb-3 w-1/2 mr-2">
                <label
                  htmlFor="date_of_birth"
                  className="block text-xs font-medium text-gray-700"
                >
                  Client Date Of Birth
                </label>
                <div className="mt-1 relative rounded-md">
                  <input
                    defaultValue={clientData.date_of_birth}
                    type="date"
                    min="1900-01-01"
                    required
                    name="date_of_birth"
                    id="date_of_birth"
                    onChange={(e) =>
                      (clientData.date_of_birth = e.target.value)
                    }
                    className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                  />
                </div>
              </div>
            </div>
          </div>
          <hr className="bg-gray-300 w-full my-4" />
          <div className="mt-6">
            <h3 className="text-md font-bold mb-2">School Contact Details</h3>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="contact_name"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Contact Name
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.client_details?.school_contact_name}
                      type="text"
                      name="contact_name"
                      required
                      disabled
                      id="contact_name"
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="contact_number"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Contact Number
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={schoolData.client_details?.phone_number}
                      type="text"
                      name="contact_number"
                      required
                      disabled
                      id="contact_number"
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>                
              </div>
          </div>
          <hr className="bg-gray-300 w-full my-4" />
          <div>
            <h3 className="text-md font-bold mb-2">
              Emergency Contact Details
            </h3>
            <div>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="emergency_contact_name"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Contact Name
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={emergencyContact.name}
                      type="text"
                      name="ec_name"
                      id="ec_name"
                      onChange={(e) =>
                        (emergencyContact.name = e.target.value)
                      }
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="ec_contact_number"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Contact Number{' '}
                    <span className="text-blue-500 text-xs">
                      (Please use +44 and no spaces)
                    </span>
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={emergencyPhoneNumber}
                      type="text"
                      required
                      minLength="3"
                      name="ec_number"
                      id="ec_number"
                      onChange={(e) => {
                        handleEmergencyPhoneNumberChange(e)
                        emergencyContact.contact_number = e.target.value
                      }}
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                    {emergencyPhoneNumber.length > 3 && (
                      <>
                        {isValid ? (
                          <span className="text-green-500 text-sm">
                            Valid phone number
                          </span>
                        ) : (
                          <span className="text-red-600 text-sm">
                            Invalid phone number
                          </span>
                        )}
                      </>
                    )}
                    <p
                      id="emailnote"
                      className={
                        !validPhoneNumber
                          ? 'instructions failed'
                          : 'offscreen'
                      }
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} />
                      This Phone number already exists, please enter a
                      different one.
                    </p>
                  </div>
                </div>
                <div className="mb-3 w-1/2 ml-2">
                  <label
                    htmlFor="ec_relationship"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Relationship to Client
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={emergencyContact.relationship}
                      type="text"
                      name="ec_relationship"
                      id="ec_relationship"
                      onChange={(e) =>
                        (emergencyContact.relationship = e.target.value)
                      }
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="client_address"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Contact Address
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <AutoComplete
                      defaultValue={emergencyContact.address}
                      type="text"
                      name="client_address"
                      required
                      id="client_address"
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                      apiKey={GOOGLE_API_KEY}
                      onPlaceSelected={(place) => {
                        const addressFormatted = place.formatted_address
                        const segments = place.address_components
                        let data = {}
                        segments.forEach((key) => {
                          const type = key.types[0]
                          data[type] = key.long_name
                        })

                        const formattedSegments =
                          addressFormatted.split(', ')

                        const address = {
                          address_line_1: data['street_number']
                            ? data['street_number'] + ' ' + data['route']
                            : formattedSegments[1],
                          address_line_2:
                            data['locality'] ?? data['political'],
                          city: data['postal_town'],
                          county: data['administrative_area_level_2'],
                          country: data['country'],
                          postcode: data['postal_code'],
                        }

                        setEmergencyContactAddress(address)
                        updateEmergencyContactAddress(address)
                      }}
                      options={{
                        types: [],
                        componentRestrictions: { country: 'gb' },
                      }}
                    />
                  </div>
                </div>
              </div>

              {emergencyContactAddress.address_line_1 && (
                <>
                  <div className="flex">
                    <div className="mb-3 w-1/2 mr-2">
                      <label
                        htmlFor="client_address_line_1"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Address Line 1
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={
                            emergencyContactAddress.address_line_1 || ''
                          }
                          type="text"
                          name="client_address_line_1"
                          required
                          id="client_address_line_1"
                          onChange={(e) => {
                            const address = emergencyContactAddress
                            address.address_line_1 = e.target.value
                            setEmergencyContactAddress({
                              ...emergencyContactAddress,
                              address_line_1: e.target.value,
                            })
                            updateEmergencyContactAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                    <div className="mb-3 w-1/2 ml-2">
                      <label
                        htmlFor="client_address_line_2"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Address Line 2 (Optional)
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={
                            emergencyContactAddress.address_line_2 || ''
                          }
                          type="text"
                          name="client_address_line_2"
                          id="client_address_line_2"
                          onChange={(e) => {
                            const address = emergencyContactAddress
                            address.address_line_2 = e.target.value
                            setEmergencyContactAddress({
                              ...emergencyContactAddress,
                              address_line_2: e.target.value,
                            })
                            updateEmergencyContactAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="mb-3 w-1/2 mr-2">
                      <label
                        htmlFor="client_city"
                        className="block text-xs font-medium text-gray-700"
                      >
                        City
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={emergencyContactAddress.city || ''}
                          type="text"
                          name="client_city"
                          required
                          id="client_city"
                          onChange={(e) => {
                            const address = emergencyContactAddress
                            address.city = e.target.value
                            setEmergencyContactAddress({
                              ...emergencyContactAddress,
                              city: e.target.value,
                            })
                            updateEmergencyContactAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                    <div className="mb-3 w-1/2 ml-2">
                      <label
                        htmlFor="client_county"
                        className="block text-xs font-medium text-gray-700"
                      >
                        County
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={emergencyContactAddress.county || ''}
                          type="text"
                          name="client_county"
                          required
                          id="client_county"
                          onChange={(e) => {
                            const address = emergencyContactAddress
                            address.county = e.target.value
                            setEmergencyContactAddress({
                              ...emergencyContactAddress,
                              county: e.target.value,
                            })
                            updateEmergencyContactAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex">
                    <div className="mb-3 w-1/2 mr-2">
                      <label
                        htmlFor="client_postcode"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Postcode
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={emergencyContactAddress.postcode || ''}
                          type="text"
                          name="client_postcode"
                          required
                          id="client_postcode"
                          onChange={(e) => {
                            const address = emergencyContactAddress
                            address.postcode = e.target.value
                            setEmergencyContactAddress({
                              ...emergencyContactAddress,
                              postcode: e.target.value,
                            })
                            updateEmergencyContactAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                    <div className="mb-3 w-1/2 ml-2">
                      <label
                        htmlFor="client_country"
                        className="block text-xs font-medium text-gray-700"
                      >
                        Country
                      </label>
                      <div className="mt-1 relative rounded-md">
                        <input
                          value={emergencyContactAddress.country || ''}
                          type="text"
                          name="client_country"
                          required
                          id="client_country"
                          onChange={(e) => {
                            const address = emergencyContactAddress
                            address.country = e.target.value
                            setEmergencyContactAddress({
                              ...emergencyContactAddress,
                              country: e.target.value,
                            })
                            updateEmergencyContactAddress(address)
                          }}
                          className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <hr className="bg-gray-300 w-full my-4" />
          <div>
            <h3 className="text-md font-bold mb-2">
              Safeguard Contact Info
            </h3>
            <div>
              <div className="flex">
                <div className="mb-3 w-1/2 mr-2">
                  <label
                    htmlFor="safeguard_name"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Lead Name
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={safeguardDetails.name}
                      type="text"
                      name="safeguard_name"
                      id="safeguard_name"
                      onChange={(e) =>
                        (safeguardDetails.name = e.target.value)
                      }
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                  </div>
                </div>
                <div className="mb-3 w-1/2 ml-2">
                  <label
                    htmlFor="safeguard_email"
                    className="block text-xs font-medium text-gray-700"
                  >
                    Email
                  </label>
                  <div className="mt-1 relative rounded-md">
                    <input
                      defaultValue={safeguardDetails.email}
                      type="safeguard_email"
                      required
                      name="email"
                      id="safeguard_email"
                      onChange={(e) =>
                        (safeguardDetails.email = e.target.value)
                      }
                      className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                    />
                    <p
                      id="emailnote"
                      className={
                        !validEmail ? 'instructions failed' : 'offscreen'
                      }
                    >
                      <FontAwesomeIcon icon={faCircleExclamation} />
                      This email already exists, please enter a different
                      one.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex">
              <div className="mb-3 w-1/2 mr-2">
                <label
                  htmlFor="safeguard_number"
                  className="block text-xs font-medium text-gray-700"
                >
                  Contact Number{' '}
                  <span className="text-blue-500 text-xs">
                    (Please use +44 and no spaces)
                  </span>
                </label>
                <div className="mt-1 relative rounded-md">
                  <input
                    defaultValue={safeguardNumber}
                    type="text"
                    required
                    minLength="3"
                    name="safeguard_number"
                    id="safeguard_number"
                    onChange={(e) => {
                      handleSafeguardPhoneNumberChange(e)
                      safeguardDetails.contact_number = e.target.value
                    }}
                    className="px-2 text-sm py-2 block w-full border border-gray-300 rounded-md shadow-md"
                  />
                  {safeguardNumber.length > 3 && (
                    <>
                      {validSafeGuardNumber ? (
                        <span className="text-green-500 text-sm">
                          Valid phone number
                        </span>
                      ) : (
                        <span className="text-red-600 text-sm">
                          Invalid phone number
                        </span>
                      )}
                    </>
                  )}
                  <p
                    id="emailnote"
                    className={
                      !validPhoneNumber
                        ? 'instructions failed'
                        : 'offscreen'
                    }
                  >
                    <FontAwesomeIcon icon={faCircleExclamation} />
                    This Phone number already exists, please enter a
                    different one.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <hr className="bg-gray-300 w-full my-4" />
          <div className="flex mt-2">
            <button
              type="submit"
              className={` ${!isValid ? 'btn disabled' : 'btn'}`}
              disabled={!isValid || submitting}
            >
              Create Client
            </button>
          </div>
        </form>

    </section>
  )
}

              // <div className="flex">
              //   <div className="mb-3 w-1/2 mr-2">
              //   </div>
              // </div>

export default CreateSchoolClient